<template>
  <div class="onlineuser-container">
    <div class="onlineuser-header">
      <div v-if="role == 3" style="position: relative">
        <p
          class="control_style_select fontsize12 pointer"
          @click.stop="controlStyle.expand = !controlStyle.expand"
        >
          {{ $t("onLineUserList.音视频控制模式") }}
          <i v-if="!controlStyle.expand" class="el-icon-arrow-down pointer"></i
          ><i class="el-icon-arrow-up pointer" v-else></i>
        </p>
        <div class="control_style" v-if="controlStyle.expand">
          <el-tooltip
            effect="dark"
            :content="$t('onLineUserList.需要获取主控权')"
            placement="top"
            :disabled="avctl === 1"
          >
            <div>
              <div class="control_style_switch">
                <span
                  :class="{ fontsize12: true, opacity__disabled: avctl === 0 }"
                  >{{ $t("onLineUserList.视频主控模式") }}</span
                >
                <el-switch
                  v-model="controlStyle.video"
                  active-color="#3986EE"
                  :disabled="avctl == 0"
                  class="blueSwitch form-dark"
                  @change="changeControl($event, 'video')"
                >
                </el-switch>
              </div>
              <p class="control_style_tips fontsize12">
                {{ $t("onLineUserList.启用后不允许嘉宾主动打开视频") }}
              </p>
            </div>
          </el-tooltip>
          <el-tooltip
            effect="dark"
            :content="$t('onLineUserList.需要获取主控权')"
            placement="top"
            :disabled="avctl === 1"
          >
            <div>
              <div class="control_style_switch">
                <span
                  :class="{ fontsize12: true, opacity__disabled: avctl === 0 }"
                  >{{ $t("onLineUserList.音频主控模式") }}</span
                >
                <el-switch
                  :disabled="avctl == 0"
                  v-model="controlStyle.audio"
                  active-color="#3986EE"
                  class="blueSwitch form-dark"
                  @change="changeControl($event, 'audio')"
                >
                </el-switch>
              </div>
              <p class="control_style_tips fontsize12">
                {{ $t("onLineUserList.启用后不允许嘉宾主动打开音频") }}
              </p>
            </div>
          </el-tooltip>
        </div>
      </div>
      <div v-if="role == 3 && avctl == 0" class="radio-button-mini">
        <el-button
          class="shouhuizhukong"
          size="mini"
          type="primary"
          @click="takebackControll()"
          >{{ $t("onLineUserList.收回主控权") }}</el-button
        >
      </div>
      <div
        v-if="role == 3 && avctl == 1 && share == 0"
        class="radio-button-mini"
      >
        <el-button
          class="shouhuizhukong"
          size="mini"
          type="primary"
          @click="takebackShowAuth()"
          >{{ $t("onLineUserList.收回演示权") }}</el-button
        >
      </div>
      <div
        v-if="phoneConnect && role == 3"
        class="onlineuser-phoneconnect"
        :class="{ 'onlineuser-phoneconnect-right': role == 1 }"
      >
        <a :href="phoneControlUrl" target="_blank" v-if="avctl == 1"
          ><img :src="require('@/svg/phone_icon.svg')"  width="12px"
        /></a>
        <a :href="phoneReadonlyUrl" target="_blank" v-if="avctl == 0"
          ><img :src="require('@/svg/phone_icon.svg')"  width="12px"
        /></a>
      </div>
      <template v-if="!phoneConnect && role == 3">
        <el-tooltip
          :content="$t('onLineUserList.电话连线功能暂不可用')"
          popper-class="tip-max"
          effect="dark"
          placement="top"
        >
          <div
            class="onlineuser-phoneconnect-disabled"
            :class="{ 'onlineuser-phoneconnect-right': role == 1 }"
          >
            <img :src="require('@/svg/phone_icon.svg')" width="12px" />
          </div>
        </el-tooltip>
      </template>
      <!-- <div v-if="role === 1">
        <p class="control_style_select fontsize12">
          <span style="margin-right: 15px">{{
            $t(`onLineUserList.${guestVideoText}`)
          }}</span>
          <span>{{ $t(`onLineUserList.${guestAudioText}`) }}</span>
        </p>
      </div> -->
      <!-- <template v-if="role === 1">
        <el-tooltip
          effect="dark"
          placement="top"
          :content="$t('controller.升级为主播')"
          :visible-arrow="false"
        >
          <div class="cursor-pointer" @click="openUpHost = true">
            <img class="text-middle" :src="require('@/svg/up_host.svg')" />
            <span class="fontsize12 text-uphost">{{ $t("onLineUserList.升级主播") }}</span>
          </div>
        </el-tooltip>
      </template> -->
    </div>

    <!-- 列表：管理列表+观众列表 -->
    <div class="onlineuser-body" id="onlineuserBodyId">
      <el-collapse
        v-model="activeNames"
        class="onlineuser-list liveCollapse"
        @change="onCollapseChange"
        id="containerResize"
      >
        <el-collapse-item
          class="onlineuser-list-item"
          v-for="u in onlineListType"
          :id="u.name + 'Resize'"
          :key="u.name"
          :name="u.name"
        >
          <template slot="title">
            {{ $t(`onlineuser.${u.title}`) }}
            <span v-if="u.name === 'controller' && hostUsersShow"
              >（{{ joinedListLength }}）</span
            >
            <span v-if="u.name != 'controller' && hostUsersShow"
              >（{{ viewerListLength }}）</span
            >
            <div
              v-if="u.name === 'controller'"
              class="onlineuser-controller-icon"
            >
              <div @click.stop="openMix" v-if="videoWall">
                <el-tooltip
                  effect="dark"
                  :content="$t('onLineUserList.嘉宾视频墙')"
                  placement="top"
                  :visible-arrow="false"
                >
                  <img v-if="isShowMix" :src="require('@/svg/mix_1.svg')" />
                  <img v-else :src="require('@/svg/mix.svg')" />
                </el-tooltip>
              </div>
              <div
                v-if="avctl == 1"
                @click.stop="muteRoom"
                style="margin-right: 12px"
              >
                <el-tooltip
                  effect="dark"
                  :content="$t('onLineUserList.一键静音')"
                  placement="top"
                  :visible-arrow="false"
                >
                  <img :src="require('@/svg/mic_close_0.svg')" />
                </el-tooltip>
              </div>
            </div>
            <div v-else class="onlineuser-search dialog-dark" @click.stop="">
              <el-input
                :placeholder="$t('onlineuser.搜索用户')"
                v-model="searchUser"
                v-if="showInput"
                @input="searchViewerList"
                @keyup.enter.native.stop="
                  () => {
                    return;
                  }
                "
              >
                <i
                  slot="suffix"
                  v-if="searchUser"
                  @click.stop="
                    showInput = false;
                    searchUser = null;
                    searchViewerList();
                  "
                  class="el-input__icon online-search-icon el-icon-error"
                ></i>
              </el-input>
              <el-tooltip
                effect="dark"
                :content="$t('onLineUserList.搜索')"
                placement="top"
              >
                <i
                  v-if="!showInput"
                  @click="() => (showInput = true)"
                  class="el-input__icon el-icon-search"
                />
              </el-tooltip>
            </div>
          </template>
          <controllerList
            v-if="u.name === 'controller'"
            ref="controllerResizeRef"
            :controller-list-height="controllerListHeight"
          >
          </controllerList>
          <viewerList
            v-if="u.name === 'viewer' && (role != 1 || guestSeeAuth != 2)"
            @changeUserNum="changeUserNum"
            ref="viewerList"
            :viewer-list-height="viewerListHeight"
          ></viewerList>
        </el-collapse-item>
      </el-collapse>
    </div>

    <!-- <UpHost :visible.sync="openUpHost" /> -->
  </div>
</template>

<script>
import { meetInfo } from "@/mixins/meet";
import { Collapse, CollapseItem, Tooltip } from "element-ui";
import controllerList from "@/components/onLineUserList/controller";
import viewerList from "@/components/onLineUserList/viewer";
import Bus from "@/components/doc/bus";
import { uuid } from "@/utils/global";
import {
  tackBackMainControl,
  tackBackShowControl,
} from "@/api/liveRequest/userApi";
import _throttle from "lodash.throttle";
import { pushRoomMessageFunc } from "@/utils/socketMessageDispose";
import rowResize from "./row-resize";
import { mapGetters } from "vuex";

export default {
  name: "userListArea",
  mixins: [meetInfo],
  props: ["phoneControlUrl", "phoneReadonlyUrl"],
  components: {
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Tooltip.name]: Tooltip,
    controllerList,
    viewerList,
  },
  data() {
    return {
      searchUser: null,
      onlineListType: [], //管理列表和观众列表
      activeNames: ["controller", "viewer"], //controller or  viewer
      isShowViewer: true,
      audioBtnName: null,
      showInput: false,
      viewerListLength: 0,
      controlStyle: {
        video: false, //0:视频主控  1：视频自由
        audio: false, //0：音频主控  1：音频自由
        expand: false,
      },
      isShowBarResize: false,
      resizeMoveLength: 100,
      controllerListHeight: 0,
      viewerListHeight: 0,
      bodyTotalHeight: 0,
      guestVideoText: "",
      guestAudioText: "",
      openUpHost: false,
      bindResize: null,
      collapseFirstHeight: "50%",
      collapseLastHeight: "50%",
    };
  },
  created() {
    this.init();
    if (this.role === 1) {
      pushRoomMessageFunc(({ cmd, requestData }) => {
        switch (cmd) {
          case 4129:
            this.handleMessage4129(requestData);
            break;
        }
      });
    }
  },
  watch: {
    guestSeeAuth() {
      this.init();
    },
    role() {
      this.init();
    },
  },
  computed: {
    ...mapGetters(["liveConfig", "shareType","videoWall"]),
    authAudio() {
      return (
        this.$store.getters.meetStatusInfo &&
        this.$store.getters.meetStatusInfo.groupInfo &&
        this.$store.getters.meetStatusInfo.groupInfo.audio
      );
    },
    authVideo() {
      return (
        this.$store.getters.meetStatusInfo &&
        this.$store.getters.meetStatusInfo.groupInfo &&
        this.$store.getters.meetStatusInfo.groupInfo.video
      );
    },
    roomAudioStatus() {
      console.log(this.$store.getters.meetStatusInfo.audio, "音频主控");
      return (
        this.$store.getters.meetStatusInfo &&
        this.$store.getters.meetStatusInfo.audio
      );
    },
    // 主控权   1：有  0：无
    avctl() {
      return (
        this.$store.getters.selfParticipant &&
        this.$store.getters.selfParticipant.avctl
      );
    },
    share() {
      return (
        this.$store.getters.selfParticipant &&
        this.$store.getters.selfParticipant.share
      );
    },
    role() {
      //3:主播 2：助手 1：嘉宾
      return (
        this.$store.getters.selfParticipant &&
        this.$store.getters.selfParticipant.type
      );
    },
    joinedListLength() {
      return (
        this.$store.getters.JoinedList &&
        this.$store.getters.JoinedList.filter((info) => {
          return info.type != undefined;
        }).length
      );
    },
    isShowMix() {
      return this.$store.getters.isShowMix;
    },
    guestSeeAuth() {
      return this.$store.getters.guestSeeAuth;
    },
    userInfo() {
      return this.$store.getters.userInfo;
    },
    ccWebsocketClient() {
      return this.$store.getters.ccWebsocketClient;
    },
    groupInfo() {
      return this.$store.getters.groupInfo;
    },
    liveId() {
      return this.$store.getters.liveId;
    },
    liveToken() {
      return this.$store.getters.liveToken;
    },
    mediaStatus() {
      return this.$store.getters.mediaStatus;
    },
    hostUsersShow() {
      return this.$store.state.liveInfo.liveConfig.is_host_users_show;
    },
    phoneConnect() {
      return this.$store.state.liveInfo.liveConfig.is_phone_connect;
    },
  },
  // beforeMount() {
  //   // resize audience height
  //   Bus.$on('changeManagerHeight', (val) => {
  //     console.log('change manager list val', val)
  //     this.resizeAudienceHeight(val)
  //   })
  // },
  mounted() {
    this.$nextTick(() => {
      document.addEventListener(
        "click",
        (e) => {
          if (typeof e.target.className !== 'string') return
          if (e.target.className && !e.target.className.includes("onlineuser-search")) {
            if (!this.searchUser) {
              this.showInput = false;
            }
          }
        },
        false
      );
      // ["controller", "viewer"].forEach((info) => {
      //   document
      //     .getElementById(`${info}Resize`)
      //     .addEventListener("keydown", (event) => {
      //       const key = event.keyCode;
      //       if (key == 13) {
      //         throw new TypeError('Incorrect value for audioActive')
      //       }
      //     });
      // });
    });

    // onlineuser-list-item
    // this.resizeAudienceHeight()
  },
  // beforeDestroy() {
  //   this.resizeBar.removeEventListener('mousedown', this.handleResizeBarMouseDown)
  // },
  methods: {
    handleMessage4129(requestData) {
      const { type, value } = requestData.requestData.set;
      if (type === "video") {
        this.guestVideoText = value === 0 ? "视频主控模式" : "视频自由模式";
      } else if (type === "audio") {
        this.guestAudioText = value === 0 ? "音频主控模式" : "音频自由模式";
      }
    },
    init() {
      let userlist = ["controller", "viewer"];
      this.onlineListType = [];
      if (this.role == 1 && this.guestSeeAuth == 2) {
        userlist = ["controller"];
      }
      userlist.forEach((u) => {
        this.onlineListType.push({
          name: u,
          title: `${u}List`,
        });
      });
      this.changeAuth();
      Bus.$on("authChange", () => {
        this.changeAuth();
      });
      if (this.bindResize) {
        this.bindResize();
        this.bindResize = null;
      }
      this.$nextTick(() => {
        this.bindResize = rowResize(true, () => {
          this.setCollapseHeight(true);
        });
      });
    },
    changeAuth() {
      this.controlStyle.audio = this.authAudio == 1 ? false : true;
      this.controlStyle.video = this.authVideo == 1 ? false : true;

      this.guestVideoText = this.controlStyle.video
        ? "视频主控模式"
        : "视频自由模式";
      this.guestAudioText = this.controlStyle.audio
        ? "音频主控模式"
        : "音频自由模式";
    },
    changeControl(value, type) {
      const status = value ? 0 : 1;
      let head = {
        cmd: 1429,
        id: this.getChatHeadId(),
      };
      let Body = {
        cid: this.groupInfo.cid,
        gid: this.groupInfo.gid,
        set: { type: type, value: status },
        act_mode: 1,
      };
      this.ccWebsocketClient.customizeSendMsg(head, Body);
      // this.changeControlStatus(status, type);
    },
    muteRoom() {
      if (
        this.liveConfig?.liveondemandVoiceStatus === 0 &&
        (this.mediaStatus == 2 || this.mediaStatus == 3)
      ) {
        this.$message.error(
          this.$t("lianmai.插播静音已开启，您暂时不能开关麦克风")
        );
        return;
      }
      let head = {
        cmd: 1429,
        id: this.getChatHeadId(),
      };
      let Body = {
        cid: this.groupInfo.cid,
        gid: this.groupInfo.gid,
        set: { type: "audio", value: 0 },
        act_mode: 0,
      };
      this.ccWebsocketClient.customizeSendMsg(head, Body);
    },
    /** 生成一个通信32位id */
    getChatHeadId() {
      return `${uuid(15, 62)}${new Date().getTime()}`;
    },
    openMix() {
      const isOpenMix = !this.isShowMix;
      if (isOpenMix) {
        this.$store.commit("SET_ISSHOWMIX", isOpenMix);
      } else {
        Bus.$emit("closeSubMix");
      }
    },
    searchViewerList() {
      console.log(this.searchUser);
      Bus.$emit("searchUserList", this.searchUser);
    },
    changeUserNum(info) {
      //this.viewerListLength = info - this.joinedListLength;
      this.viewerListLength = info;
      Bus.$emit("changeUserNum", info);
    },
    // 收回主控权
    takebackControll() {
      tackBackMainControl(this.liveId, this.liveToken).then((res) => {
        if (res && res.code == 200) {
          this.$message.success(this.$t("onLineUserList.收回成功"));
        } else {
          this.$message.error(`收回失败:${res.msg}`);
        }
      });
    },
    // 收回演示权
    takebackShowAuth() {
      this.$confirm(this.$t("controller.若原演示权人正在演示文档或共享桌面"), '', {
          confirmButtonText: this.$t("controller.继续"),
          cancelButtonText: this.$t("controller.取消")
        }).then(() => {
          this.tackBackControl();
        }).catch(() => {

        });
    },
    tackBackControl() {
      tackBackShowControl(this.liveId, this.liveToken).then((res) => {
        if (res && res.code == 200) {
          this.$message.success(this.$t("controller.收回成功"));
        } else {
          this.$message.error(`${this.$t("controller.收回失败")}:${res.msg}`);
        }
      });
    },
    async onCollapseChange(e) {
      let { first, last } = this.setCollapseHeight(false);
      const firstHeight = "5%",
        lastHeight = "95%";
      if (e.length == 0 || (e.length == 1 && e[0] == "viewer")) {
        //观众和管理列表都折叠
        first.style.height = firstHeight;
        last.style.height = lastHeight;
      } else if (e.length == 2) {
        //都展开
        first.style.height = this.collapseFirstHeight;
        last.style.height = this.collapseLastHeight;
      } else {
        first.style.height = lastHeight;
        last.style.height = firstHeight;
      }
      if (e === "viewer") {
        await this.$nextTick();
        console.log(this.$refs.viewerList, "this.$refs.viewerList");
        this.$refs.viewerList[0] &&
          this.$refs.viewerList[0].updateScrollHeight();
      }
    },
    resizeAudienceHeight() {
      // const container = document.getElementById('containerResize');
      // this.resizeBar = document.getElementById('barResize');
      // const topBox = document.getElementById('controllerResize');
      // const downBox = document.getElementById('viewerResize');
      const onlineuserBody = document.querySelector("#onlineuserBodyId");
      this.bodyTotalHeight = onlineuserBody.clientHeight;
      this.controllerListHeight = this.bodyTotalHeight / 2 - 33;
      this.viewerListHeight = this.bodyTotalHeight / 2 - 38;
      // this.resizeBar.addEventListener(
      // 'mousedown',
      // (e) => this.handleResizeBarMouseDown(e, container, topBox, downBox, this.resizeBar)
      // )
    },
    handleResizeBarMouseDown(mouseDownEvent, container, topBox, downBox, bar) {
      mouseDownEvent.preventDefault();
      mouseDownEvent.stopPropagation();
      document.onselectstart = () => false;
      document.ondragstart = () => false;
      const startY = mouseDownEvent.clientY;
      this.resizeMoveLength = topBox.clientHeight;
      bar.top = bar.offsetTop;
      document.onmousemove = _throttle((e) => {
        const endY = e.clientY;
        let moveLength = this.resizeMoveLength + (endY - startY);

        if (moveLength < 33) moveLength = 33;
        if (moveLength > this.bodyTotalHeight - 38)
          moveLength = this.bodyTotalHeight - 38;

        topBox.style.height = moveLength + "px";
        downBox.style.height = container.clientHeight - moveLength - 10 + "px";
        this.controllerListHeight = moveLength - 33;
        this.viewerListHeight = this.bodyTotalHeight - moveLength - 38;
      }, 20);
      document.onmouseup = () => {
        this.resizeMoveLength = parseInt(
          topBox.style.height.replace(/px$/, "")
        );
        document.onmousemove = null;
        document.onmouseup = null;
        document.onselectstart = null;
        document.ondragstart = null;
      };
    },
    setCollapseHeight(isSet) {
      const wrapper = document.querySelector(".onlineuser-list");
      const first = wrapper.querySelector(".onlineuser-list-item");
      const last = wrapper.querySelector(".onlineuser-list-item:last-child");
      if (first === last) return;
      if (isSet) {
        this.collapseFirstHeight = first.style.height;
        this.collapseLastHeight = last.style.height;
      }
      return { first, last };
    },
  },
};
</script>

<style  lang="scss">
.onlineuser-container {
  height: calc(100% - 58px);
}
.onlineuser-header {
  width: 251px;
  height: 34px;
  margin: 0 auto;
  padding-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  &:empty {
    height: 10px;
  }
  .onlineuser-btn {
    border-color: $bule-color;
    background-color: transparent;
    color: $bule-color;
    width: 66px;
    height: 24px;
    line-height: 24px;
    padding: 0px;
  }
  .onlineuser-phoneconnect {
    width: 34px;
    height: 22px;
    background: #3986ee;
    border-radius: 4px;
    line-height: 25px;
    border-radius: 10px;
    cursor: pointer;
    a {
      width: 30px;
      height: 22px;
      display: inline-block;
    }
  }
  .onlineuser-phoneconnect-disabled {
    width: 34px;
    height: 22px;
    background: #3986ee;
    border-radius: 10px;
    line-height: 25px;
    opacity: 0.5;
    cursor: not-allowed;
  }
  .onlineuser-phoneconnect-right {
    position: absolute;
    right: 11px;
  }
}
.onlineuser-body {
  height: calc(100% - 50px);
  .onlineuser-list {
    height: 100%;
    width: 280px;
    margin: auto;
    border-color: $chatusertabbg-color;
    border: none;
    position: relative;
    display: flex;
    flex-direction: column;
    .onlineuser-list-item {
      position: relative;
      height: 50%;
      .resize-bar {
        position: absolute;
        width: 100%;
        height: 3px;
        top: 0px;
        left: 0;
        border-radius: 10px;
        cursor: n-resize;
        background-color: transparent;
        &:hover {
          background-color: #409eff;
        }
      }
    }
    .el-collapse-item__header {
      position: relative;
      background-color: $chatusertabbg-color;
      color: $gray6-color;
      border-radius: 4px;
      border-color: $chatusertabbg-color;
      padding-left: 10px;
    }
    .el-collapse-item__content {
      padding-bottom: 0px;
    }
    .el-collapse-item__wrap {
      background-color: transparent;
      border: none;
    }
    .onlineuser-controller-icon {
      position: absolute;
      right: 32px;
      height: 32px;
      line-height: 32px;
      z-index: 0;
      div {
        display: inline-block;
        overflow: hidden;
        margin-right: 19px;

        img {
          vertical-align: middle;
        }

        // img {
        //   filter: drop-shadow($gray6-color 80px 0);
        //   -webkit-filter: drop-shadow($gray6-color 80px 0);
        //   transform: translateX(-80px);
        // }
      }
    }
  }
}
.onlineuser-search {
  display: inline-block;
  width: 88px;
  position: absolute;
  right: 35px;
  input {
    height: 24px;
    background-color: $chatusertabbg-color;
    // border-color: $chatusertabbg-color;
    line-height: 24px;
    padding: 5px;
    color: #fff;
    font-size: 12px;
    border-color: #acb2bf;
    &::placeholder {
      color: #8a8f99;
    }
  }
  .el-icon-error {
    position: absolute;
    top: 3px;
    right: -5px;
    line-height: 24px;
    color: #8a8f99;
  }
  .el-icon-search {
    float: right;
  }
}
.control_style_select {
  color: #acb2bf;
}
.control_style {
  width: 170px;
  background-color: #2d3052;
  padding: 15px 15px 3px 15px;
  position: absolute;
  z-index: 20;
  top: 26px;
  border-radius: 4px;
  > div {
    height: 50px;
  }
  .control_style_switch {
    color: #fff;
    display: flex;
    justify-content: space-between;
  }
  .control_style_tips {
    color: #727480;
    margin-top: 2px;
  }
}
.shouhuizhukong {
  width: 74px;
  height: 22px;
  padding: 0;
  border-radius: 4px;
  border: 1px solid #3986ee;
  font-size: 12px;
  color: #3986ee;
  background-color: transparent;
}

.el-collapse-item__wrap {
  height: calc(100% - 33px);
}

.el-collapse-item__content {
  height: 100%;
}

.opacity__disabled {
  opacity: 0.6;
}
.text-uphost{
  color: #ACB2BF;
  margin-left: 5px;
}
</style>
